export const metricsFilterParams = [
  'search',
  'country_code',
  'weight__gte',
  'weight__lte',
  'unit_cost__gte',
  'unit_cost__lte',
  'category_id',
  'status',
  'has_export_price',
  'export_price_country',
]
